import React, { Component } from "react";
import "../css/CheckRegister.css";
import image from "../images/member-logo-white.svg";
import { HOST_URL } from "../constants";
import { connect } from "react-redux";
import { loginPopup } from "../models";
import { AUTO_LOGIN_URL } from "../constants";
import isUrlEn from "../function/isUrlEn";
import getCookie from "../function/getCookie";
import i18n from "i18next";
import { Helmet } from "react-helmet";

class CheckRegister extends Component {
  state = {
    pinCode: "",
    pinCodeError: false,
    generateForm: false,
    autoLoginFormData: {
      mobileCountryCode: "",
      mobileNumber: "",
      password: ""
    }
  };

  handleCode = e => {
    const { value } = e.target;
    this.setState({
      pinCode: value
    });
  };

  componentDidMount() {
    const { state } = this.props.location;

    if (state) {
      // 生成form表單，並在此頁面自動登入
      this.setState({
        generateForm: true,
        autoLoginFormData: state.autoLoginFormData
      });
    }

    /*先抓URL判斷語系*/
    const url = window.location.pathname;
    isUrlEn(url);
    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系
    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }
  }

  getCodeAgain = async () => {
    // 重新取得驗證碼
    await fetch(
      `${HOST_URL}/shopping/v1/customers/notifications/sms/pincodes`,
      {
        credentials: "include",
        method: "POST",
        headers: {
          "content-type": "application/json"
        }
      }
    ).then(response => {
      if (response.status === 204) {
        alert("發送驗證碼成功");
      } else {
        window.logApiErrors(
          "r",
          "getCodeAgain",
          response.status,
          response.statusText
        );
      }
    });
  };

  submitPinCode = async () => {
    const data = {
      pinCode: this.state.pinCode
    };
    await fetch(`${HOST_URL}/shopping/v1/customers/sms-verifications`, {
      credentials: "include",
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(data)
    }).then(response => {
      if (response.status === 204) {
        // 自動登入
        if (window.opener) {
          console.log("opener");
          window.opener.postMessage("AUTO_LOGIN", "*");
        } else if (window.parent) {
          console.log("parent");
          window.parent.postMessage("AUTO_LOGIN", "*");
        }
        const form = document.getElementById("login-form");
        if (form) {
          // 在此頁面自動登入
          form.submit();
        }
        // 關閉畫面
        // window.parent.postMessage("CLOSE_PINCDOE_POPUP", "*");
      } else {
        window.logApiErrors(
          "r",
          "submitPinCode",
          response.status,
          response.statusText
        );
        this.setState({
          pinCodeError: true
        });
      }
    });
  };

  render() {
    const { pinCode, pinCodeError, generateForm, lang } = this.state;
    const { mobileCountryCode, mobileNumber, password } =
      this.state.autoLoginFormData;
    const url = window.location.origin;
    const description =
      lang === "en"
        ? "At EMPHASIS, we embrace different styles and looks, resonating with the tastes of women from all walks of life. Our original designs are more than pretty accessories. They are designed to complete your look and express your individuality. We live in a world that imposes expectations on beauty. Our logo, featuring the stylised outline of an unconventional crown, is a proud symbol of our mission to challenge these expectations and let your inner strength shine through. Crown the Beautiful You."
        : "EMPHASIS 的原創珠寶不僅精緻瑰麗，我們獨特多變的設計更能圓滿妳的妝容服飾，展露自我風格。妳我縱使身處受標準審美限制的大時代，但我們品牌標誌上象徵富棱角的后冠能賦予妳勇於衝破枷鎖的力量，讓妳盡情綻放自己的獨特個性，閃爍耀眼。冠冕女性之美。";

    return (
      <>
        <Helmet>
          <title>EMPHASIS</title>
          <meta name="description" content={description} />
        </Helmet>
        <div className="check-rg-content">
          <div className="check-rg-header">
            <img src={image} alt="" />
          </div>
          <div className="check-rg-body">
            <h1 className="check-rg-title">請填寫您的驗證碼</h1>
            <p className="check-rg-subtitle">驗證碼已傳送至您的手機</p>
            <div className="check-code-section">
              <p>驗證碼：</p>
              <input type="text" value={pinCode} onChange={this.handleCode} />
            </div>
            {pinCodeError ? (
              <div className="pin-code-error">驗證碼輸入錯誤</div>
            ) : null}
            <div className="check-button-section">
              <button className="try-again-btn" onClick={this.getCodeAgain}>
                重新傳送
              </button>
              <button className="submit-code-btn" onClick={this.submitPinCode}>
                提交
              </button>
            </div>
            <p>如超過10分鐘仍未能收到手機驗證碼，請於辦公時間聯絡顧客服務</p>
          </div>
          {generateForm ? (
            <>
              <form
                id="login-form"
                style={{ display: "none" }}
                method="POST"
                action={`${AUTO_LOGIN_URL}?service=${url}`}
              >
                <input id="login-auto" name="auto" value="true" type="hidden" />
                <input
                  id="login-username"
                  name="username"
                  type="hidden"
                  value={mobileCountryCode + mobileNumber}
                  readOnly
                />
                <input
                  id="login-password"
                  name="password"
                  type="password"
                  style={{ display: "none" }}
                  value={password}
                  readOnly
                  autoComplete="true"
                />
                <input
                  id="login-style"
                  name="style"
                  value="popup"
                  type="hidden"
                />
              </form>
            </>
          ) : null}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    active: state.loginPopup.active
  };
};
const mapDispatchToProps = () => {
  return {
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckRegister);
